export interface DeprecatedChipProps {
  renderRoot?: HTMLElement
  size?: 'small' | 'medium'
  showDismiss?: boolean
  text: string
  emphasisText?: string
  onClose?: () => void
  [x: string]: unknown
}
